import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
// import { ToasterService } from '../services/toaster.service';
import { RouterLink } from '@angular/router';
import { config } from '../config';
import { environment } from '../../environments/environment';
// import *  as  productsMapping from './products-list.json';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.css']
})
export class ProgressComponent implements OnInit {

  requestedQuotesList: any = [];
  config: any = config;
  environment: any = environment;
  actionUrl: any;
  // productsList: any = (productsMapping as any).default;
  userDetails: any = {};
  loading: boolean = false;
  quoteLength: any = 10;

  isClaimIntimated:boolean=false;
  intimationNumber:string;
  error:string;
  claimsStatus: any = [];
  claimUnderProcess: any=[];
  intimatedDate:any;

  product:any;

  Claim_Intimated = 'Claim Intimated';
  Acknowledged = 'Acknowledged by Insurer';
  IntialDocumentSubmitted = 'Intial Document Submitted';
  ClaimUnderProcess = 'Claim Under Process';
  paid = 'Paid';
  intimationNo: any;
  claimInfo:any;
  registeredDate:any;

  claimstatusdetails:any;
  claimstatuscomment:any;

  documentsdDate:any

  AcknowledgedByinsurer:any;
  isAcknowledgedByinsurer:boolean;
  isactiveinsurebutton:boolean=false;

  isactivedocumentbutton:boolean=false;

  ispendingforendorsement:boolean=false;

  pendingforendorsement='Pending for Endorsement';

  getdocument:any;
  isgetdocument:boolean;
  finalStatus:boolean;
  getamounts:string;
  isgetamounts:boolean;
  dateByinsurer:any;
  dateByPendingEndorsement:any;
  finalStatusName:string;
  finalStatusDate:any;

  showpaid:boolean = false;

  isoutstanding:boolean;

  count = 0;

  outstandingSubStatus:any = [];
  pendingForendorsement:false;



  intimationList;
  intimationListData : [];
  // error: string;
  // loading: boolean;
  // intimationNo: any;
  // claimInfo: any;
  claimHistory:any;
  isHistory:boolean=false;
  mobileNumber: string;
  employeeName: string;
  policyNumber: string;
  claimant: string;
  relationWithEmployee: string;
  cardNumber: string;
  ailment: string;
  hospitalCity: string;
  hospitalName: string;
  estimatedAmount: string;
  admissionDate: string;
  dischargeDate: string;
  registeredDate1: string;
  // intimationNumber: string;
  status: string;
  claimStage: string;
  approvedAmount: string;
  claimNoByInsurer: string;
  checkStatusDetails: boolean = false;
  datecreate:string;
  selectedIntimation: string = "";
  underRegistration:boolean=false;
  underRegistrationDate:any;
  underMedical:any;
  underMedicalDate:any;
  underMedicalAfterQuery:any;
  underMedicalAfterQueryDate:any;
  underAudit:any;
  underAuditDate:any;
  underInvestigation:any;
  underInvestigationDate:any;
  underClaimRepresentation: any;
  underClaimRepresentationDate: any;
  underQueryDocuments:any;
  underQueryDocumentsDate:any;
  reopeningApproval:any;
  reopeningApprovalDate:any;
  delayApproval:any;
  delayApprovalDate:any;
  claimApproved:any;
  claimApprovedDate:any
  partialClaim: any
  partialClaimDate: any

  
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService, private router1: ActivatedRoute, ) { 

  }

  ngOnInit() {
    this.finalStatusName = 'Paid/Rejected/Closed'
    this.actionUrl = this.environment.pam2Url + this.config.returningUserQuote;

    this.intimationNo = this.router1.snapshot.params['id'];
    
    this.getClaimInfoByIntimation();
    // this.getClaimDetailByIntimationNo();
    this.getClaimDetailByIntimationNo(this.intimationNo);
  
  }

  //claim history status

  getClaimInfoByIntimation(){
    this.serviceURLService.getClaimHistoryByIntimations(this.intimationNo).subscribe((success: any) => {
      this.claimsStatus = success.response.pamResponse.data[0];
      this.claimUnderProcess = success.response.pamResponse.data[1];

      this.claimstatuscomment = this.claimUnderProcess.updateComment;
    
      this.intimatedDate = this.claimsStatus[0].lastUpdated;
      if(this.claimsStatus[0].claimsStatus=='Claim Intimated'){
        this.isClaimIntimated=true;
      }
      
      this.getByInsurer();
      this.getdocuments() ;

      if(this.claimsStatus[1] && this.claimUnderProcess[0]){
        this.isoutstanding=true;
                        for(var i=0; i<this.claimUnderProcess.length; i++){
                            if(this.claimUnderProcess[i].claimStage == "Under registration with insurer")
                            {
                                this.underRegistration = true
                                this.underRegistrationDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Under Medical Scrutiny(Fresh Claim)")
                            {
                                this.underMedical = true
                                this.underMedicalDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Under Medical Scrutiny(After query reply)")
                            {
                                this.underMedicalAfterQuery = true
                                this.underMedicalAfterQueryDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Under audit")
                            {
                                this.underAudit = true
                                this.underAuditDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Under investigation/Survey")
                            {
                                this.underInvestigation = true
                                this.underInvestigationDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Under Claim Representation") 
                            {
                              this.underClaimRepresentation = true;
                              this.underClaimRepresentationDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Under Query")
                            {
                                this.underQueryDocuments = true
                                this.underQueryDocumentsDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Reopening approval requested from insurer")
                            {
                                this.reopeningApproval = true
                                this.reopeningApprovalDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Referred to Insurer for Delay intimation/submission approval")
                            {
                                this.delayApproval = true
                                this.delayApprovalDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Partial Claim")
                            {
                                this.partialClaim = true
                                this.partialClaimDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Claim approved / Ready for payment")
                            {
                                this.claimApproved = true
                                this.claimApprovedDate = this.claimUnderProcess[i].lastUpdated
                            }
                            else if(this.claimUnderProcess[i].claimStage == "Pending for endorsement")
                            {
                                this.ispendingforendorsement =true;
                                this.dateByPendingEndorsement = this.claimUnderProcess[this.claimUnderProcess.length-1].lastUpdated

                            }

                        }

                

      }

      if(this.claimsStatus[1] && this.claimsStatus[1].claimsStatus=='PAID'){
        var element = document.getElementById("progressBarofEclaims");
        element.classList.add("step_heights");
        this.finalStatus = true
        this.finalStatusName = 'Paid'
        this.finalStatusDate = this.claimsStatus[1].lastUpdated
        this.showpaid = true;
        this.claimstatuscomment=this.claimsStatus[1].updateComment;
    }

    else if(this.claimsStatus[1] && this.claimsStatus[1].claimsStatus=='REJECTED/REPUDIATED'){
        var element = document.getElementById("progressBarofEclaims");
        element.classList.add("step_heights");
        this.finalStatus = true
        this.finalStatusDate = this.claimsStatus[1].lastUpdated
        this.finalStatusName = 'Rejected/Repudiated'
        this.claimstatuscomment=this.claimsStatus[1].updateComment;
    }

    else if(this.claimsStatus[1] && this.claimsStatus[1].claimsStatus=='CLOSED'){
         var element = document.getElementById("progressBarofEclaims");
        element.classList.add("step_heights");
        this.finalStatus = true
        this.finalStatusName = 'closed'
        this.finalStatusDate = this.claimsStatus[1].lastUpdated
        this.claimstatuscomment=this.claimsStatus[1].updateComment;

    }

         
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }

  

  getByInsurer(){
    this.serviceURLService.getnoByInsurer(this.intimationNo).subscribe((success: any) => {
      this.AcknowledgedByinsurer = success.response.pamResponse.data.claimNumber;
      this.dateByinsurer = success.response.pamResponse.data.date;

  
      if(this.AcknowledgedByinsurer==='NA' || this.AcknowledgedByinsurer==='' || this.AcknowledgedByinsurer===null) {
        this.isClaimIntimated=true;
        this.isAcknowledgedByinsurer = false
      } 
      else{
        this.isClaimIntimated=true;
        this.isAcknowledgedByinsurer = true;
        this.isactiveinsurebutton = true;
        
    }
   
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });

    return this.AcknowledgedByinsurer
  }

  getdocuments(){
  
    this.serviceURLService.getdocuments(this.intimationNo).subscribe((success: any) => {
      this.getdocument = success.response.pamResponse.data ?Object.keys(success.response.pamResponse.data).length:0;
      this.documentsdDate = success.response.pamResponse.timeStamp;

      if(this.getdocument<2){
        this.isClaimIntimated=true;
        //this.isAcknowledgedByinsurer = true
        this.isgetdocument = false
       }
       else{
        this.isClaimIntimated=true;
        //this.isAcknowledgedByinsurer = true
        this.isgetdocument = true;
        this.isactivedocumentbutton = true;
        this.documentsdDate = success.data.date
        }
    
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
    return this.getdocument
  }

  getamount(){
    // this.intimationNumber='SNGHI2021SNTSTG263';
    this.serviceURLService. getgetamount(this.intimationNo).subscribe((success: any) => {
      this.getamounts = success.data;

      if((this.getamounts == "NA" || this.getamounts == null) || this.getamounts == "null"){
        this.isgetamounts = false;
       }


       else{
        
        if(this.isAcknowledgedByinsurer){
         this.isgetamounts = true;
        }
        else{
         this.isgetamounts = false;
        }

      
      }
      

    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }


  getClaimDetailByIntimationNo(intimationNo) {
    // intimationNo = this.selectedIntimation;
    // const intimationNo1 = this.selectedIntimation;
    if(intimationNo == "" || intimationNo == null) {
      this.error = "Claim Registration number is required.";
    } else {
    this.loading = true;
    this.checkStatusDetails = true;
    this.serviceURLService.getClaimInfoByIntimationNo(intimationNo).subscribe((successData: any) => {
      this.loading = false;
      this.claimInfo = successData.response.pamResponse.data;
      for (var i = 0; i < this.claimInfo.length; i++) {
        this.employeeName = this.claimInfo[i].employeeName;
        this.policyNumber = this.claimInfo[i].policyNumber;
        this.claimant = this.claimInfo[i].claimant;
        this.relationWithEmployee = this.claimInfo[i].relationWithEmployee;
        this.cardNumber = this.claimInfo[i].cardNumber;
        this.ailment = this.claimInfo[i].ailment;
        this.hospitalCity = this.claimInfo[i].hospitalCity;
        this.hospitalName = this.claimInfo[i].hospitalName;
        this.estimatedAmount = this.claimInfo[i].estimatedAmount;
        this.admissionDate = this.claimInfo[i].admissionDate;
        this.dischargeDate = this.claimInfo[i].dischargeDate;
        this.registeredDate1 = this.claimInfo[i].dateCreated;
        this.intimationNumber = this.claimInfo[i].intimationNo;
        this.status = this.claimInfo[i].status;
        this.claimStage = this.claimInfo[i].claimStage ? this.claimInfo[i].claimStage : '-';
        this.approvedAmount = this.claimInfo[i].approvedAmount;
        if(this.approvedAmount == null) {
          this.approvedAmount = '-';
        }
        this.claimNoByInsurer = this.claimInfo[i].claimNoByInsurer;
        this.datecreate= this.registeredDate1.split("T")[0];
      }

    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }
  }

  transform(value:string): string {
    let first = value.substr(0,1).toUpperCase();
    return first + value.substr(1); 
  }


}